module.exports = __webpack_public_path__ + "static/media/reactjs.da1f7718.svg";